import { type TypedDocumentNode, gql } from '@apollo/client';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useIntlContext } from '@sorare/core/src/contexts/intl';

import type { GameweekDate_so5Fixture } from './__generated__/index.graphql';

type Props = { so5Fixture?: GameweekDate_so5Fixture };
export const GameweekDate = ({ so5Fixture }: Props) => {
  const { formatDate } = useIntlContext();

  return (
    <Horizontal gap={0.5} style={{ display: 'inline-flex' }}>
      <span>
        {formatDate(so5Fixture?.startDate, {
          month: 'short',
        })}
      </span>
      <span>
        {formatDate(so5Fixture?.startDate, {
          day: '2-digit',
        })}
        -
        {formatDate(so5Fixture?.endDate, {
          day: '2-digit',
        })}
      </span>
    </Horizontal>
  );
};

GameweekDate.fragments = {
  so5Fixture: gql`
    fragment GameweekDate_so5Fixture on So5Fixture {
      slug
      startDate
      endDate
    }
  ` as TypedDocumentNode<GameweekDate_so5Fixture>,
};
